import { useState } from "react";

import { useGetProfileData }         from "_common/hooks/auth";
import { useSetIsBlockedByStreamer } from "_common/hooks/global";
import {
	getBlockedUsersList,
	getMutedUsersList,
	getTopDonor
} from "_services/firebase/broadcast";
import remoteConfigInstance from "_services/firebase/fetchRemoteConfig";

import list from "../chatEmotesList";

const mapEmotes = data => {
	return data.reduce ( ( acc, item ) => {
		acc[item.name] = { reactionId: item.id, url: item.url, name: item.name };

		return acc;
	}, {} );
};

export const useChat = ( { broadcastId, isStreamer } ) => {

	const [ emotesList, setEmotesList ]                   = useState ( {} );
	const [ topDonor, setTopDonor ]                       = useState ( [] );
	const [ sendUpdatedComments, setSendUpdatedComments ] = useState ( true );
	const [ myMutedStateData, setMyMutedStateData ]       = useState ( {} );
	const setBlockedByStreamer                            = useSetIsBlockedByStreamer ();
	const userProfile                                     = useGetProfileData ();

	let __mutedUsersList;
	let __blockedUsersList;
	let __topDonorListener;

	const toggleBlockedUser = blockedList => {
		blockedList.forEach ( ele => {

			const data = ele.doc && ele.doc.data ();

			if ( data.id === userProfile?.id ) {
				// if delete == true that means user is removed from blocked list
				const isBlocked = !data.deleted;

				if ( isBlocked )
					setBlockedByStreamer ( true );
				else
					setBlockedByStreamer ( false );
			}
		} );
	};
	const blockedUsersListListener = async () => {
		return await getBlockedUsersList ( broadcastId, doc => {
			toggleBlockedUser ( doc.docChanges () );
		} );
	};

	const topDonorListener = async () => {
		return await getTopDonor ( broadcastId, doc => {
			doc.docChanges ().forEach ( ele => {
				const data = ele.doc && ele.doc.data ();

				const { pinningDuration, timestamp } = data;

				const currentTime = Date.now ();
				const difference  = currentTime - timestamp;

				if ( difference < pinningDuration * 1000 ) {
					const duration = ( pinningDuration * 1000 - difference ) / 1000;

					return setTopDonor ( prevVal => [ ...prevVal, { ...data, pinningDuration: duration } ] );
				} else {
					return;
				}
			} );
		} );
	};
	const fetchEmotesList = async () => {
		let remoteConfigEmotes = await remoteConfigInstance.getData ( "sportx", "emotes_list_v2" );

		if ( !remoteConfigEmotes ) {

			remoteConfigEmotes = list.default;
		}
		const data = mapEmotes ( remoteConfigEmotes );

		setEmotesList ( data );
	};

	const toggleMutedUserList = mutedUserList => {
		mutedUserList.forEach ( ele => {
			const data = ele.doc && ele.doc.data ();

			if ( data.id === userProfile?.id ) {
				if ( ele.type === "removed" ) {
					setMyMutedStateData ( { ...data, isUnmuted: true } );

					return;
				}
				setMyMutedStateData ( data );
			}
		} );
	};
	const mutedUsersListListener = async () => {

		return await getMutedUsersList ( broadcastId, doc => {
			toggleMutedUserList ( doc.docChanges () );
		} );
	};

	const init = async () => {
		// reset ();

		if ( !Object.keys ( emotesList ).length )
			await fetchEmotesList ();

		__topDonorListener = await topDonorListener ();

		if ( !isStreamer )
			__blockedUsersList = await blockedUsersListListener ();

		__mutedUsersList = await mutedUsersListListener ();
	};

	const clearListeners = () => {
		if ( __topDonorListener )
			__topDonorListener ();

		if ( __blockedUsersList )
			__blockedUsersList ();

		if ( __mutedUsersList )
			__mutedUsersList ();
	};

	const removeDonor = val => {
		setTopDonor ( prevVal => {
			const updatedList = [];

			prevVal.map ( item => {
				if ( item.id === val )
					return null;

				updatedList.push ( item );
			} );

			return updatedList;
		} );
	};

	return {
		init,
		clearListeners,
		myMutedStateData: {
			value : myMutedStateData,
			set   : setMyMutedStateData
		},
		topDonor   : topDonor,
		removeDonor,
		emotesList : {
			value : emotesList,
			set   : setEmotesList
		},
		sendUpdatedComments: {
			value : sendUpdatedComments,
			set   : setSendUpdatedComments
		}
	};
};
